<template>
  <!-- pc -->
  <div
    v-if="windowWidth >= 600 && windowHeight >= 600"
    class="wrapper-earnPoint"
  >
    <div class="h-100">
      <div
        class="image__hearder"
        crm_at="image_hearder"
        :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
      >
        <div class="box_content">
          <div class="wrapper__earnpoint__page">
            <div class="wrapper_hearder">
              <LayoutHome />
            </div>
            <div class="wrapper_content">
              <mainmission :storeinfo="storeinfo.mission" :classspx="'pc'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- mobile -->
  <mainmission v-else :storeinfo="storeinfo.mission" :classspx="'mobile'" />
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import Locale from '@/helper/Locale.js'
import LayoutHome from '@/module/components/Home/LayoutHome'
import mainmission from '../MissionHub/components/missionmain.vue'
import Account from '@/helper/AccountHelper.js'
export default {
  name: 'Invited',
  components: { LayoutHome, mainmission },
  mixins: [CommonMixin, ResponsiveMixin],
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
        mission: {
          ShowCheckInMission7Days: false,
          ShowCampaignSurveyBanner: false,
          ShowCampaignEnterCodeBanner: false,
          ShowCampaignFriendGetFriendBanner: false,
          LinkSurvey: null,
        },
      },
    }
  },
  created() {
    Account.bzbsAnalyticTracking(
      'mission_page',
      'mission_page',
      'view_mission_page',
      'on view',
    )
    this.local = Locale.getLocale()
    this.getCustomerStore()
    this.handleLanguage(true)
    this.handleshowFGF(false)
    this.handleFooter(true)
    this.handleLoading(false)
  },
  methods: {
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor

      this.storeinfo.image_header = data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = data.StoreDetail.LogoUrl
      this.storeinfo.businessName = data.StoreDetail.BusinessName
      this.storeinfo.mission.ShowCheckInMission7Days =
        data.StoreDetail.ShowCheckInMission7Days
      this.storeinfo.mission.ShowCampaignSurveyBanner =
        data.StoreDetail.ShowCampaignSurveyBanner
      this.storeinfo.mission.ShowCampaignEnterCodeBanner =
        data.StoreDetail.ShowCampaignEnterCodeBanner
      this.storeinfo.mission.ShowCampaignFriendGetFriendBanner =
        data.StoreDetail.ShowCampaignFriendGetFriendBanner
      this.storeinfo.mission.LinkSurvey = data.StoreDetail.LinkSurvey
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_mixin.scss';
$font-title-size: 16px;
$font-text-size: 12px;
$font-main-color: #424242;
$dropshadowmain: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
$bordermain: solid 1px #f5f5f5;
.mainmissionhub {
  .modalcheckin {
    position: fixed;
    top: 50%;
    left: 50%;
    visibility: hidden;
    opacity: 0;
    text-align: center;
    box-shadow: $dropshadowmain;
    transform: translate(-50%, -50%);
    width: 273px;
    padding: 30px;
    border-radius: 10px;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease-in-out;
    .text {
      font-size: $font-title-size;
      font-weight: 600;
      color: $font-main-color;
    }
    &.show {
      visibility: visible;
      opacity: 1;
    }
  }
  .modalgotpoint {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.8);
    transition: all 0.3s ease-in-out;
    .modalinside {
      width: 343px;
      text-align: center;
      padding: 24px 16px;
      border-radius: 10px;
      background-color: #fff;
      position: relative;
      .title {
        font-size: 20px;
        font-weight: 500;
        color: $font-main-color;
      }
      .point {
        font-size: 40px;
        color: #212121;
      }
      .detail {
        font-size: 14px;
        color: #757575;
      }
      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #000;
      }
    }
    &.show {
      visibility: visible;
      opacity: 1;
    }
  }
}

.wrapper-earnPoint {
  .img-code {
    margin-top: -4px;
  }

  .code-success {
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
    color: #4caf50;
    padding-right: 5px;
  }

  .code-error {
    font-size: 14px;
    font-weight: 500;
    font-style: italic;
    color: #ff5252;
    padding-right: 5px;
  }

  .events-none {
    pointer-events: none;
  }

  .ant-input-group {
    width: 100%;
    height: 45px;
    border-radius: 20px !important;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 16%);
    margin: 8px 0;
  }

  .ant-input {
    float: left;
    text-align: inherit;
    width: 100%;
    height: 45px;
    box-shadow: initial;
    border: solid 1px #ededed;
    background-color: #fff;
    padding: 10px 0px 10px 15px;
    font-size: 16px;
    color: #616161;
    font-weight: 500;
    border-top-left-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: initial;
  }

  .ant-btn-lg {
    text-align: inherit;
    height: 45px;
    box-shadow: initial;
    border: solid 1px #ededed;
    background-color: #fff;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
    border-left: initial;
  }

  .ant-input-group-addon {
    background-color: transparent;
  }

  .input_earncode {
    width: 100%;
    height: 45px;
    border-radius: 20px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ededed;
    background-color: #fff;
    margin: 8px 0;
    padding: 10px 15px;
    font-size: 16px;
    color: #616161;
    font-weight: 500;
  }

  .title-code {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    color: #9e9e9e;
    padding-top: 4px;
  }
  .img-earnpoint {
    padding-top: 12px;
    width: 100%;
  }

  .lbl-point {
    flex-grow: 0;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
    text-align: left;
    color: #232323;
    padding-left: 16px;
  }

  .lbl-point-w {
    font-weight: 800;
  }

  .box-profile {
    text-align: left;
    display: flex;
  }

  .wrapper-detail {
    padding-left: 15px;
    padding-right: 15px;

    .earnpoint-explanation {
      font-size: 16px;
      margin-top: 16px;
    }
  }

  .btn-submit {
    width: 100%;
    height: 40px;
    font-size: 20px;
    font-weight: 600;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
    cursor: pointer;
  }

  .profile_image {
    width: 65px;
    height: 65px;
    margin: 0;
    border-radius: 50px;
  }
}

.wrapper-earnPoint {
  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) {
    .wrapper__earnpoint__page {
      border-top-left-radius: 40px;
      border-top-right-radius: 40px;
      margin-top: -50px;
      background-color: white;
      .title {
        padding: 10px;
        .text-title {
          font-size: 18px;
          font-weight: 500;
          margin-left: 10px;
          color: #666;
          line-height: 1.17;
        }
      }
      padding: 0px 5px;

      .wrapper_hearder {
        padding: 20px 20px 0 20px;
      }

      .wrapper_content {
        padding: 0 20px 0 20px;
      }
    }

    height: 100%;
    width: 100%;
    .wrapper__earnpoint__page {
      width: 90%;
      top: 20%;
      margin-top: 20px;
      margin-bottom: 50px;
      border-radius: 10px;
      .wrapper_content {
        margin-top: 10px;
      }
    }

    .image__hearder {
      height: 100%;
      overflow: auto;
      background-repeat: round;
      background-size: cover;
    }

    .box_content {
      min-height: 100%;
      align-items: center;
      -webkit-box-align: center;
      justify-content: center;
      vertical-align: middle;
      display: flex;
      width: 100%;
    }

    .footer {
      margin: 85px 0 10px 0;
      padding-bottom: 10px;
      .container {
        position: relative;
        bottom: 0px;
      }
    }
  }

  @media only screen and (min-device-width: 600px) and (min-device-height: 600px) and (orientation: landscape) {
    .wrapper__earnpoint__page {
      margin-top: 80px !important;
      margin-bottom: 100px !important;
    }
  }

  @media only screen and (min-device-width: 900px) {
    .wrapper__earnpoint__page {
      width: 75%;
    }
  }

  @media only screen and (min-device-width: 1200px) {
    .wrapper__earnpoint__page {
      width: 60%;
    }
  }

  //แนวนอน
  @media only screen and (orientation: landscape) {
    .bzb__logo {
      position: relative;
    }
  }

  //แนวนอน
  @media only screen and (min-device-width: 640px) and (max-device-width: 823px) and (orientation: landscape) {
    .box_content {
      min-height: 740px;
    }
  }
}
</style>
